import React from 'react';
import { CustomFormMultiSelect } from 'shared/components/ui/custom-form-multi-select';
import { Option, Size } from 'shared/components/ui/custom-form-select';
import { Icon } from 'shared/components/ui/icon';
import { ID } from 'shared/types/id';
import { v4 as uuidv4 } from 'uuid';

import * as Styled from './popup-menu.style';

export type PopupMenuMultiSelectProps = {
  label: string;
  options: Option[];
  onChange: (id: ID, value?: string[]) => void;
  selectedValue?: string[];
  id?: string;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  placeholder?: string;
  level?: number;
  compact?: boolean;
  recursiveSelection?: boolean;
};

export const PopupMenuMultiSelect: React.FC<PopupMenuMultiSelectProps> = ({
  label,
  options,
  onChange,
  selectedValue,
  placeholder,
  icon,
  id = uuidv4(),
  level,
  compact,
  recursiveSelection,
}) => {
  const _onChange = (value?: string[]) => onChange(id, value);

  return (
    <Styled.Select htmlFor={id} $level={level} $compact={!!compact}>
      {!!icon && (
        <Styled.AffixContainer $isSelected={false}>
          <Styled.IconContainer>
            <Icon icon={icon} />
          </Styled.IconContainer>
        </Styled.AffixContainer>
      )}
      <Styled.SelectContent>
        {label}
        <CustomFormMultiSelect
          id={id}
          onChange={_onChange}
          options={options}
          value={selectedValue}
          placeholder={placeholder}
          size={Size.ExtraSmall}
          recursiveSelection={recursiveSelection}
        />
      </Styled.SelectContent>
    </Styled.Select>
  );
};
